
export function createXLSheetdata(attritionList) {
    attritionList.find((ticketDetails, index) => {                


                delete attritionList[index]['id']

                attritionList[index].UrbanpiperId=attritionList[index].up_id
                delete attritionList[index]['up_id']


                delete attritionList[index]['product_id']


                attritionList[index].MenuName=attritionList[index].name                
                delete attritionList[index]['name']

                attritionList[index].MenuPrice=attritionList[index].price                
                delete attritionList[index]['price']

                attritionList[index].ERPAG_SKU=attritionList[index].sku
                delete attritionList[index]['sku']

                attritionList[index].ERPAG_Name=attritionList[index].sku_name
                delete attritionList[index]['sku_name']

                delete attritionList[index]['sku_combined']
                delete attritionList[index]['product_id']


                attritionList[index].MenuType=attritionList[index].type                
                delete attritionList[index]['type']


                attritionList[index].MenuCategory=attritionList[index].category
                delete attritionList[index]['category']

                attritionList[index].MenuCity=attritionList[index].city
                delete attritionList[index]['city']



                delete attritionList[index]['city_id']
                delete attritionList[index]['city_id']
            
                return false
            })   
            return attritionList
}



// WEBPACK FOOTER //
// ./src/modules/Menus/services/helpers.js